import { PLFlag, GBFlag, DEFlag, RUFlag } from 'mantine-flagpack';
import { pl, enGB, de, ru } from 'date-fns/locale';

const LANGUAGES = {
	PL: {
		name: 'Polski',
		code: 'pl',
		displayCode: 'PL',
		flag: PLFlag,
		dateFnsLocale: pl,
	},
	EN: {
		name: 'English',
		code: 'en',
		displayCode: 'EN',
		flag: GBFlag,
		dateFnsLocale: enGB,
	},
	DE: {
		name: 'Deutsch',
		code: 'de',
		displayCode: 'DE',
		flag: DEFlag,
		dateFnsLocale: de,
	},
	RU: {
		name: 'Русский',
		code: 'ru',
		displayCode: 'RU',
		flag: RUFlag,
		dateFnsLocale: ru,
	},
	// FR: {
	// 	name: 'Français',
	// 	code: 'fr',
	// 	displayCode: 'FR',
	// 	flag: FRFlag,
	// 	dateFnsLocale: fr,
	// },
} as const;

export default LANGUAGES;
